import { useState } from "react";
import useCurrentUserData from "../../../../hooks/useCurrentUserData";
import Game from "../../../../store/Game";
import useCurrentGame from "../../../../hooks/useCurrentGame";

export default function useController() {
  const [isGamePurchased, setIsGamePurchased] = useState(false);
  const [isGameCreated, setIsGameCreated] = useState(false);
  const [isGameCreating, setIsGameCreating] = useState(false);
  const [newGame, setNewGame] = useState([]);
  const { getUserData } = useCurrentUserData();
  const { setGame } = useCurrentGame();

  const createNewGame = async () => {
    setIsGameCreating(true);
    const userData = getUserData();
    await Game.createNewGame(userData.id, (game) => {
      setGame(game);
    });
    setIsGameCreating(false);
  };

  const removeGame = (id) => {
    setNewGame(newGame.filter((game) => game.id === id));
    setIsGameCreated(false);
  };

  const buyGame = () => {
    setIsGameCreated(false);
    setIsGamePurchased(false);
  };

  return {
    createNewGame,
    removeGame,
    buyGame,
    isGamePurchased,
    isGameCreated,
    isGameCreating,
    newGame,
  };
}
